import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  EstimatorHookApiResponse,
  EstimatorHookResponse,
  updateEstimatorHook,
  checkHookPermission,
  getMyEstimatorHookDetail,
} from "./estimatorHookAction";

interface EstimatorHookState {
  estimatorHook: EstimatorHookResponse | null;
  loading: boolean;
  error: string | null;
}

const initialState: EstimatorHookState = {
  estimatorHook: null,
  loading: false,
  error: null,
};

const estimatorHookSlice = createSlice({
  name: "estimatorHook",
  initialState,
  reducers: {
    resetEstimatorHookState: (state) => {
      state.estimatorHook = null;
      state.loading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Handle updateEstimatorHook
      .addCase(updateEstimatorHook.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(
        updateEstimatorHook.fulfilled,
        (state, action: PayloadAction<EstimatorHookApiResponse>) => {
          state.loading = false;
          state.estimatorHook = action.payload.data?.estimatorHook || null;
          state.error = null;
        }
      )
      .addCase(
        updateEstimatorHook.rejected,
        (state, action: PayloadAction<string | undefined>) => {
          state.loading = false;
          state.error = action.payload || "Failed to update estimator hook";
        }
      )
      // Handle checkHookPermission
      .addCase(checkHookPermission.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(
        checkHookPermission.fulfilled,
        (state, action: PayloadAction<EstimatorHookApiResponse>) => {
          state.loading = false;
          state.estimatorHook = action.payload.data?.estimatorHook || null;
          state.error = null;
        }
      )
      .addCase(
        checkHookPermission.rejected,
        (state, action: PayloadAction<string | undefined>) => {
          state.loading = false;
          state.error = action.payload || "Failed to verify permission";
        }
      )
      // Handle getMyEstimatorHookDetail
      .addCase(getMyEstimatorHookDetail.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(
        getMyEstimatorHookDetail.fulfilled,
        (state, action: PayloadAction<EstimatorHookApiResponse>) => {
          state.loading = false;
          state.estimatorHook = action.payload.data?.estimatorHook || null;
          state.error = null;
        }
      )
      .addCase(
        getMyEstimatorHookDetail.rejected,
        (state, action: PayloadAction<string | undefined>) => {
          state.loading = false;
          state.error =
            action.payload || "Failed to retrieve estimator hook details";
        }
      );
  },
});

export const { resetEstimatorHookState } = estimatorHookSlice.actions;
export default estimatorHookSlice.reducer;
